import React, { useState, Fragment } from "react";
import styled, { css, ThemeProvider } from "styled-components";
import Colorer from "color";
import { Svg } from "../uikit-b2c/Svg";
import { CssFormGroup } from '../uikit-b2c/uikit-b2c';
import { InputM } from '../uikit-b2c/InputM';



export const PSmethods = ({
  search= false,
  show = [],
  rows,
  limit,
  name = true,
  tooltip = false,
  methods = [],
  width = 90,
  compact,
  theme,
  more,
  height = 36,
  handle,
  monochrome = false,
}) => {
  const [hovered, setHovered] = useState(0);
  return (<Fragment>

    {search && <CssFormGroup indentation='lg'>
      <div style={{
        display: 'grid',
        width: '100%',
        gridTemplateColumns: '1fr 220px',
        gridColumnGap: 16,
      }}>
      <InputM
        label={<span>Search</span>}
        theme={theme}
        size='sm'
        style={{width: '100%'}}
      />
      <InputM
        label={<span>🇺🇸 USA</span>}
        size='sm'
        style={{width: '100%'}}
      />
      </div>
    </CssFormGroup>}

    <CSSmethods
      width={width}
      compact={compact}
    >
      {Object.keys(methods).map((oneMethId, ind) => {
        if (
          // methods[oneMethId]["default"] &&
          methods[oneMethId]["on"] &&
          (typeof limit === "undefined" || ind < limit)
        )
          return (
            <CSSoneMethod
              width={width}
              flatten={handle ? false : true}
              compact={compact}
              priority={hovered === ind ? true : false}
              key={`methods_${ind}`}
              // onClick={() => setAct("methods")}
              onClick={() => {
                handle && handle(oneMethId);
              }}
              onMouseEnter={() => setHovered(ind)}
              monochrome={monochrome}
            >
              <CSSsvgMethod
                // width={width-20}
                // forceHeight={height ? height : false}
                // height={width}
                // png={methods[oneMethId]["png"]}
                hovered={hovered === ind ? true : false}
                color={
                  monochrome
                    ? hovered === ind
                      ? theme["colorAccentText"]
                      : // : null
                        theme["colorAccent"]
                    : null
                }
              >
                {methods[oneMethId]["icon"]}
              </CSSsvgMethod>

              {(!compact) && (
                <CSSoneMethodLabel>
                  {" "}
                  {methods[oneMethId]["label"]}
                </CSSoneMethodLabel>
              )}
            </CSSoneMethod>
          );
      })}
      {Boolean(more) && <CSSoneMethod
        width={width}
        compact={compact}
        key={`methods_more`}
        onClick={() => {
          handle('choose');
        }}
      >
        {more}
      </CSSoneMethod>}
    </CSSmethods>


    </Fragment>
  );
};



export const CssIcon = styled.div`
  font-family: 'MaterialIcons' !important;
  font-size: 24px;
`



export const CSSmethods = styled.div`
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${({width}) => width ? `${width}px` : '90px'}, 1fr));
  text-align: center;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
`;


export const CSSoneMethodLabel = styled.div`
  font-size: 11px;
  font-weight: 500;
`;


export const CSSsvgMethod = styled(Svg)`
  height: ${({forceHeight}) => forceHeight ? `${forceHeight}px` : 'auto'}
`;

export const CSSoneMethod = styled.div`
  line-height: 1em;
  /* padding: ${(props) => `${props.theme["paddings"]}px`} ${(props) =>
  `${props.theme["paddings"] * 2}px`}; */
  flex-grow: 1;
  flex-direction: column;
  padding: ${({compact}) => compact ? '4px 4px 4px 4px;' : '16px 4px 8px 4px;'};
  transition: all 150ms ease-in-out;
  min-height: ${({compact}) => compact ? '40px' : '90px'};
  align-self: stretch;
  /* margin: 0 8px; */
  display: flex;
  justify-content: ${({compact}) => compact ? 'center' : 'flex-start'};
  align-items: center;
  cursor: pointer;
  z-index: 1;
  position: relative;
  overflow: hidden;
  border-radius: ${({theme, flatten}) => flatten ? 'none' : `${theme["borderRadius"]/3}px`};


  ${({ priority }) =>
    !priority &&
    css`
            color: ${(props) => props.theme["colorAccent"]};
            /* background: ${(props) => props.theme["colorAccent"]}; */
            box-shadow: ${({theme, flatten}) => flatten ? 'none' : `inset 0 0 0px 1px ${Colorer(theme["colorAccent"])
                .alpha(0.3)
                .string()}`};
          `}


  ${({ monochrome }) =>
    monochrome &&
    css`
      ${({ onClick }) => {
        typeof onClick === "function" &&
          css`
            &:hover {
              opacity: 0.5;
              /* background: red; */
            }
          `;
      }}

      ${({ priority }) =>
        priority &&
        css`
          color: ${(props) => props.theme["colorAccentText"]};
          background: ${(props) => props.theme["colorAccent"]};
        `}
    `}


  ${({ monochrome }) =>
    !monochrome &&
    css`

      /* background: white; */
      color: black;
      ${({ priority }) =>
        priority &&
        css`
          box-shadow: inset 0 0 4px 0px
            ${(props) => `${Colorer(props.theme["colorAccent"])
              .alpha(0.8)
              .string()}
        `};
        `}



      &::after {
            content: '';
            position: absolute;
            left: 0px;
            right: 0px;
            top: 0px;
            bottom: 0px;
            z-index: -1;
            background-color: white;
            ${({ priority, flatten }) =>
              priority && !flatten &&
              css`
                background-color: ${(props) => `${Colorer(
                  props.theme["colorAccent"]
                )
                  .alpha(0.6)
                  .string()}
            `};
              `}
            ${({ flatten }) => flatten &&
              css`
                background-color: transparent;
                padding: 0;
              `}

      &:hover {
        background: ${(props) => `${Colorer(props.theme["colorAccent"])
          .alpha(0.3)
          .string()}
          `};
      }

  `}

`;
